// removed by extract-text-webpack-plugin
module.exports = {"base":"Reasons_base--3yxkL","question":"Reasons_question--3MTMP"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLeaving/components/Reasons/Reasons.scss
// module id = 2414
// module chunks = 11